import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import Sidebar from "../components/layout/Sidebar";
import PageHeader from "../components/PageHeader";
import MyGroups from "../components/layout/GroupsRenderer";
import { getUserInfo } from "../services/api";
import "../styles/home.css";

function Groups() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [headerOffset, setHeaderOffset] = useState('132.5px');

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await getUserInfo();
        setUser(userData);
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  // Measure header height and set offset for mid breakpoint
  useEffect(() => {
    const updateHeaderOffset = () => {
      const headerContent = document.querySelector('.page-header .header-content');
      if (!headerContent) return;
      const isSingleAction = headerContent.classList.contains('single-action');
      setHeaderOffset(isSingleAction ? '72.5px' : '132.5px');
    };

    // measure after render flush
    requestAnimationFrame(updateHeaderOffset);
    window.addEventListener('resize', updateHeaderOffset);
    return () => window.removeEventListener('resize', updateHeaderOffset);
  }, [showCreateForm]);

  const headerActions = [
    {
      label: '+ Create Group',
      onClick: () => setShowCreateForm(true),
      className: 'btn btn-primary'
    }
  ];

  if (loading) {
    return (
      <>
        <div className="groups-page-context" style={{ ['--groups-header-offset']: headerOffset }}>
          <Sidebar user={user} />
          <div className="main-sec">
            <div className="home-container">
              <PageHeader title="Pickl Groups" actions={headerActions} />
              <div className="loading-spinner">
                <div className="spinner"></div>
                <p>Loading groups...</p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="groups-page-context" style={{ ['--groups-header-offset']: headerOffset }}>
        <Sidebar user={user} />
        <div className="main-sec">
          <div className="home-container">
            <PageHeader title="Pickl Groups" actions={headerActions} />
            <div className="groups-content">
              <MyGroups showCreateForm={showCreateForm} setShowCreateForm={setShowCreateForm} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Groups;
